"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_LENGTH_FOR_FIRST_NAME_AND_LAST_NAME = exports.EXPIRATION_DATE_SEPARATOR = exports.MIN_MONTH_FOR_EXPIRATION_DATE = exports.MAX_MONTH_FOR_EXPIRATION_DATE = exports.MAX_YEAR_FOR_EXPIRATION_DATE = exports.FIRST_TWO_DIGITS_OF_THE_CURRENT_CENTURY = void 0;
exports.FIRST_TWO_DIGITS_OF_THE_CURRENT_CENTURY = 20;
exports.MAX_YEAR_FOR_EXPIRATION_DATE = 2040;
exports.MAX_MONTH_FOR_EXPIRATION_DATE = 12;
exports.MIN_MONTH_FOR_EXPIRATION_DATE = 1;
exports.EXPIRATION_DATE_SEPARATOR = '/';
exports.MIN_LENGTH_FOR_FIRST_NAME_AND_LAST_NAME = 3;
